import moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  actionDownload,
  resetDownloadPolicyResponse,
} from "../../dashboard/store";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
} from "../../../../../common/app_constant";
import { toast } from "react-hot-toast";

const QuoteDetails = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  // const initialData = location.state?.data;
  const [initialData, setInitialData] = useState(null);
  const { setValue, control, watch } = useForm();
  const navigate = useNavigate();
  const watchQuoteType = watch("quote_type");
  const [document, setDocument] = useState([]);
  const [employeeDocuments, setEmployeeDocuments] = useState([]);

  const { downloadPolicy } = useSelector((state) => ({
    ...state.dashboardStore,
  }));

  useEffect(() => {
    setInitialData(JSON.parse(localStorage.getItem("detailsData")));
  });

  useEffect(() => {
    if (initialData && initialData !== null) {
      Object.keys(initialData).forEach((key) => {
        setValue(key, initialData[key]);
      });
    }
    setDocument(initialData?.documents);
    setEmployeeDocuments(initialData?.neftDocuments);
  }, [initialData]);

  useEffect(() => {
    if (downloadPolicy !== null) {
      dispatch(resetDownloadPolicyResponse());
      if (downloadPolicy.status === true) {
        if (downloadPolicy.status === true && Array.isArray(downloadPolicy.data.urls)) {
          downloadPolicy.data.urls.forEach(item => {
            if (item.url) {
              window.open(item.url, '_blank');
            }
          });
        }
      } else {
        switch (downloadPolicy.status_code) {
          case 400:
            toast.error(downloadPolicy.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [downloadPolicy]);

  useEffect(() => {
    if (initialData) {
      const registrationDate = moment(initialData?.registration_date);
      const currentDate = moment();
      const yearsDiff = currentDate.diff(registrationDate, "years");
      const adjustedVehicleAge = yearsDiff >= 0 ? yearsDiff : 0;
      setValue("vehicle_age", adjustedVehicleAge);
    }
  }, [initialData]);


  return (
    <>
      <section className="pb-5">
        <div className="card mb-5 mt-6">
          <div className="card-header bg-primary  d-flex justify-content-between">
            Quote Details
            {/* <h6
              className="text-white mb-0 cursor-pointer"
              onClick={(event) => {
                event.preventDefault();
                navigate(-1);
              }}
            >
              Back
            </h6> */}
          </div>
          <div className="card-body">
            <form noValidate autoComplete="Off">
              <div className="form-body">
                <div className="row mb-3">
                  {/* Vehical Details */}
                  <div className="col-12 border-bottom mb-2">
                    <h6 className="text-primary">Vehicle Details</h6>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="quote_type" className="label-control">
                        Quote Type
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="quote_type"
                          name="quote_type"
                          render={({ field }) => {
                            return (
                              <label
                                id="quote_type_label"
                                className="border-0 fw-bold"
                              >
                                {field.value}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="product_name" className="label-control">
                        Product Name
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="product_name"
                          name="product_name"
                          render={({ field }) => {
                            return (
                              <label
                                id="product_name_label"
                                className="border-0 fw-bold"
                              >
                                {field.value}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="user_name" className="label-control">
                        Employee Name
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="userDetails.full_name"
                          name="userDetails.full_name"
                          render={({ field }) => {
                            return (
                              <label
                                id="user_name_label"
                                className="border-0 fw-bold"
                              >
                                {field.value}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {watchQuoteType != "New" && (
                    <div className="col-12 col-md-3 mb-3">
                      <div className="form-group">
                        <label
                          htmlFor="previous_policy_no"
                          className="label-control"
                        >
                          Previous Policy No
                        </label>
                        <div className="my-1">
                          <Controller
                            className="form-control"
                            control={control}
                            id="previous_policy_no"
                            name="previous_policy_no"
                            render={({ field }) => {
                              return (
                                <label
                                  id="previous_policy_no_label"
                                  className="border-0 fw-bold"
                                >
                                  {field.value}
                                </label>
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="renewal_month" className="label-control">
                        Renewal Month
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="renewal_month"
                          name="renewal_month"
                          render={({ field }) => {
                            return (
                              <label
                                id="renewal_month_label"
                                className="border-0 fw-bold"
                              >
                                {field.value}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="insured_name" className="label-control">
                        Insured Name (Customer Name)
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="insured_name"
                          name="insured_name"
                          render={({ field }) => {
                            return (
                              <label
                                id="insured_name_label"
                                className="border-0 fw-bold"
                              >
                                {field.value}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="insured_pancard_no"
                        className="label-control"
                      >
                        Insured PAN Card No
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="insured_pancard_no"
                          name="insured_pancard_no"
                          render={({ field }) => {
                            return (
                              <label
                                id="insured_pancard_no_label"
                                className="border-0 fw-bold"
                              >
                                {field.value}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Policy Detials  */}
                  <div className="col-12 border-bottom mb-2">
                    <h6 className="text-primary">Policy Details </h6>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="policy_sub_type"
                        className="label-control"
                      >
                        Policy Sub Type
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="policy_sub_type"
                          name="policy_sub_type"
                          render={({ field }) => {
                            return (
                              <label
                                id="policy_sub_type_label"
                                className="border-0 fw-bold"
                              >
                                {field.value}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {watchQuoteType != "New" && (
                    <>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            htmlFor="previous_insurer"
                            className="label-control"
                          >
                            Previous Insurer
                          </label>
                          <div className="my-1">
                            <Controller
                              className="form-control"
                              control={control}
                              id="previous_insurer"
                              name="previous_insurer"
                              render={({ field }) => {
                                return (
                                  <label
                                    id="previous_insurer_label"
                                    className="border-0 fw-bold"
                                  >
                                    {field.value}
                                  </label>
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            htmlFor="previous_policy_start_date"
                            className="label-control"
                          >
                            Previous Policy Start Date
                          </label>
                          <div className="my-1">
                            <Controller
                              className="form-control"
                              control={control}
                              id="previous_policy_start_date"
                              name="previous_policy_start_date"
                              render={({ field }) => {
                                return (
                                  <label
                                    id="previous_policy_start_date_label"
                                    className="border-0 fw-bold"
                                  >
                                    {field.value && field.value !== null
                                      ? moment(field.value).format("DD-MM-YYYY")
                                      : "-"}
                                  </label>
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            htmlFor="previous_policy_end_date"
                            className="label-control"
                          >
                            Previous Policy End Date
                          </label>
                          <div className="my-1">
                            <Controller
                              className="form-control"
                              control={control}
                              id="previous_policy_end_date"
                              name="previous_policy_end_date"
                              render={({ field }) => {
                                return (
                                  <label
                                    id="previous_policy_end_date_label"
                                    className="border-0 fw-bold"
                                  >
                                    {field.value && field.value !== null
                                      ? moment(field.value).format("DD-MM-YYYY")
                                      : "-"}
                                  </label>
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            htmlFor="previous_tp_policy_start_date"
                            className="label-control"
                          >
                            Previous TP Policy Start Date
                          </label>
                          <div className="my-1">
                            <Controller
                              className="form-control"
                              control={control}
                              id="previous_tp_policy_start_date"
                              name="previous_tp_policy_start_date"
                              render={({ field }) => {
                                return (
                                  <label
                                    id="previous_tp_policy_start_date_label"
                                    className="border-0 fw-bold"
                                  >
                                    {field.value && field.value !== null
                                      ? moment(field.value).format("DD-MM-YYYY")
                                      : "-"}
                                  </label>
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            htmlFor="previous_tp_policy_end_date"
                            className="label-control"
                          >
                            Previous TP Policy End Date
                          </label>
                          <div className="my-1">
                            <Controller
                              className="form-control"
                              control={control}
                              id="previous_tp_policy_end_date"
                              name="previous_tp_policy_end_date"
                              render={({ field }) => {
                                return (
                                  <label
                                    id="previous_tp_policy_end_date_label"
                                    className="border-0 fw-bold"
                                  >
                                    {field.value && field.value !== null
                                      ? moment(field.value).format("DD-MM-YYYY")
                                      : "-"}
                                  </label>
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {/* END */}
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="new_policy_start_date"
                        className="label-control"
                      >
                        New Policy Start Date
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="new_policy_start_date"
                          name="new_policy_start_date"
                          render={({ field }) => {
                            return (
                              <label
                                id="new_policy_start_date_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? moment(field.value).format("DD-MM-YYYY")
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="new_policy_end_date"
                        className="label-control"
                      >
                        New Policy End Date
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="new_policy_end_date"
                          name="new_policy_end_date"
                          render={({ field }) => {
                            return (
                              <label
                                id="new_policy_end_date_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? moment(field.value).format("DD-MM-YYYY")
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="rto_location" className="label-control">
                        RTO Location
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="rto_location"
                          name="rto_location"
                          render={({ field }) => {
                            return (
                              <label
                                id="rto_location_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="usage" className="label-control">
                        Usage
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="usage"
                          name="usage"
                          render={({ field }) => {
                            return (
                              <label
                                id="usage_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="segment" className="label-control">
                        Segment
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="segment"
                          name="segment"
                          render={({ field }) => {
                            return (
                              <label
                                id="segment_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="make" className="label-control">
                        Vehicle Make
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="make"
                          name="make"
                          render={({ field }) => {
                            return (
                              <label
                                id="vehicle_make_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="model" className="label-control">
                        Vehicle Model
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="model"
                          name="model"
                          render={({ field }) => {
                            return (
                              <label
                                id="vehicle_model_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="variant" className="label-control">
                        Vehicle Variant
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="variant"
                          name="variant"
                          render={({ field }) => {
                            return (
                              <label
                                id="vehicle_variant_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="engine_no" className="label-control">
                        Vehicle Engine No
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="engine_no"
                          name="engine_no"
                          render={({ field }) => {
                            return (
                              <label
                                id="engine_no_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="chassis_no" className="label-control">
                        Chassis Number
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="chassis_no"
                          name="chassis_no"
                          render={({ field }) => {
                            return (
                              <label
                                id="chassis_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="fuel_type" className="label-control">
                        Fuel Type
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="fuel_type"
                          name="fuel_type"
                          render={({ field }) => {
                            return (
                              <label
                                id="fuel_type_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="seating_capacity"
                        className="label-control"
                      >
                        Seating Capacity
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="seating_capacity"
                          name="seating_capacity"
                          render={({ field }) => {
                            return (
                              <label
                                id="seating_capacity_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="cc" className="label-control">
                        Cubic capacity (CC)
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="cc"
                          name="cc"
                          render={({ field }) => {
                            return (
                              <label
                                id="cubic_capacity_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="registration_number"
                        className="label-control"
                      >
                        Vehicle Number(Reg. No.)
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="registration_number"
                          name="registration_number"
                          render={({ field }) => {
                            return (
                              <label
                                id="vehicle_no_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="year_of_manufacturing"
                        className="label-control"
                      >
                        Year of Manufacturing
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="year_of_manufacturing"
                          name="year_of_manufacturing"
                          render={({ field }) => {
                            return (
                              <label
                                id="year_of_manufacturing_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div class="form-group has-search">
                      <label for="registration_date" class="form-label">
                        Registration Date
                      </label>
                      {/* <span class="fa fa-calendar form-control-feedback"></span> */}
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="registration_date"
                          name="registration_date"
                          render={({ field }) => {
                            return (
                              <label
                                id="registration_date_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? moment(field.value).format("DD-MM-YYYY")
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="vehicle_age" className="label-control">
                        Vehicle Age
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="vehicle_age"
                          name="vehicle_age"
                          render={({ field }) => {
                            return (
                              <label
                                id="vehicle_age_label"
                                className="border-0 fw-bold"
                              >
                                {field.value !== null ? field.value : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="nominee_name_age_relationship"
                        className="label-control"
                      >
                        Nominee Name/Age/Relationship
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="nominee_name_age_relationship"
                          name="nominee_name_age_relationship"
                          render={({ field }) => {
                            return (
                              <label
                                id="nominee_name_age_relationship_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Quote Details   */}
                  <div className="col-12 border-bottom mb-2">
                    <h6 className="text-primary">Quote Details </h6>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="previous_add_on_value"
                        className="label-control"
                      >
                        Previous Add-On Value
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="previous_add_on_value"
                          name="previous_add_on_value"
                          render={({ field }) => {
                            return (
                              <label
                                id="add_on_premium_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="claim_date" className="label-control">
                        Claim Date
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="claim_date"
                          name="claim_date"
                          render={({ field }) => {
                            return (
                              <label
                                id="claim_date_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? moment(field.value).format("DD-MM-YYYY")
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="expiring_ncb" className="label-control">
                        Expiring NCB %
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="expiring_ncb"
                          name="expiring_ncb"
                          render={({ field }) => {
                            return (
                              <label
                                id="expiring_ncb_label"
                                className="border-0 fw-bold"
                              >
                                {field.value !== null ? field.value : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="current_year_ncb"
                        className="label-control"
                      >
                        Current Year NCB %
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="current_year_ncb"
                          name="current_year_ncb"
                          render={({ field }) => {
                            return (
                              <label
                                id="current_year_ncb_label"
                                className="border-0 fw-bold"
                              >
                                {field.value !== null ? field.value : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label
                                                htmlFor="expiring_idv_vne"
                                                className="label-control"
                                            >
                                                Expiring IDV VNE
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="expiring_idv_vne"
                                                    name="expiring_idv_vne"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='expiring_idv_vne_label' className='border-0 fw-bold'>{field.value && field.value !== null ? field.value : '-'}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div> */}
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="expiring_idv_vne"
                        className="label-control"
                      >
                        Expiring IDV (Vehicle + Non electrical)
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="expiring_idv_vne"
                          name="expiring_idv_vne"
                          render={({ field }) => {
                            return (
                              <label
                                id="expiring_idv_vne_label"
                                className="border-0 fw-bold"
                              >
                                {field.value !== null ? field.value : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="expiring_external_body_idv"
                        className="label-control"
                      >
                        Expiring External Body IDV
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="expiring_external_body_idv"
                          name="expiring_external_body_idv"
                          render={({ field }) => {
                            return (
                              <label
                                id="expiring_external_body_idv_label"
                                className="border-0 fw-bold"
                              >
                                {field.value !== null ? field.value : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="expiring_cng_idv"
                        className="label-control"
                      >
                        Expiring CNG IDV
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="expiring_cng_idv"
                          name="expiring_cng_idv"
                          render={({ field }) => {
                            return (
                              <label
                                id="expiring_cng_idv_label"
                                className="border-0 fw-bold"
                              >
                                {field.value !== null ? field.value : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="current_year_idv"
                        className="label-control"
                      >
                        Current Year IDV
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="current_year_idv"
                          name="current_year_idv"
                          render={({ field }) => {
                            return (
                              <label
                                id="current_year_idv_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="current_idv_vne"
                        className="label-control"
                      >
                        Current IDV VNE
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="current_idv_vne"
                          name="current_idv_vne"
                          render={({ field }) => {
                            return (
                              <label
                                id="current_idv_vne_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="current_electrical_idv"
                        className="label-control"
                      >
                        Current Electrical IDV
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="current_electrical_idv"
                          name="current_electrical_idv"
                          render={({ field }) => {
                            return (
                              <label
                                id="current_electrical_idv_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="current_cng_idv"
                        className="label-control"
                      >
                        Current CNG IDV
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="current_cng_idv"
                          name="current_cng_idv"
                          render={({ field }) => {
                            return (
                              <label
                                id="current_cng_idv_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="current_total_idv"
                        className="label-control"
                      >
                        Current Total IDV
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="current_total_idv"
                          name="current_total_idv"
                          render={({ field }) => {
                            return (
                              <label
                                id="current_total_idv_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="tariff_rate" className="label-control">
                        Tariff Rate (%)
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="tariff_rate"
                          name="tariff_rate"
                          render={({ field }) => {
                            return (
                              <label
                                id="tariff_rate_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="factor" className="label-control">
                        Factor
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="factor"
                          name="factor"
                          render={({ field }) => {
                            return (
                              <label
                                id="factor_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="tariff_premium" className="label-control">
                        Tariff Premium
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="tariff_premium"
                          name="tariff_premium"
                          render={({ field }) => {
                            return (
                              <label
                                id="tariff_premium_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="total_tariff_premium"
                        className="label-control"
                      >
                        Total Tariff Premium
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="total_tariff_premium"
                          name="total_tariff_premium"
                          render={({ field }) => {
                            return (
                              <label
                                id="total_tariff_premium_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="discount" className="label-control">
                        Discount
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="discount"
                          name="discount"
                          render={({ field }) => {
                            return (
                              <label
                                id="discount_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="od_discount" className="label-control">
                        OD Discount
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="od_discount"
                          name="od_discount"
                          render={({ field }) => {
                            return (
                              <label
                                id="od_discount_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="od_premium" className="label-control">
                        OD Premium
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="od_premium"
                          name="od_premium"
                          render={({ field }) => {
                            return (
                              <label
                                id="od_premium_label"
                                className="border-0 fw-bold"
                              >
                                {field.value !== null ? field.value : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="ncb_discount" className="label-control">
                        NCB Discount
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="ncb_discount"
                          name="ncb_discount"
                          render={({ field }) => {
                            return (
                              <label
                                id="ncb_discount_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="net_od_premium" className="label-control">
                        Net OD Premium
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="net_od_premium"
                          name="net_od_premium"
                          render={({ field }) => {
                            return (
                              <label
                                id="net_od_premium_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="base_tp_premium"
                        className="label-control"
                      >
                        Base TP Premium
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="base_tp_premium"
                          name="base_tp_premium"
                          render={({ field }) => {
                            return (
                              <label
                                id="base_tp_premium_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="ll_owner_driver_pd_imt_28"
                        className="label-control"
                      >
                        LL Owner Driver PD IMT 28
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="ll_owner_driver_pd_imt_28"
                          name="ll_owner_driver_pd_imt_28"
                          render={({ field }) => {
                            return (
                              <label
                                id="ll_owner_driver_pd_imt_28_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="ll_to_employees_imt_29"
                        className="label-control"
                      >
                        LL to Employees IMT 29
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="ll_to_employees_imt_29"
                          name="ll_to_employees_imt_29"
                          render={({ field }) => {
                            return (
                              <label
                                id="ll_to_employees_imt_29_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="pa_for_unnamed_imt_16"
                        className="label-control"
                      >
                        PA for Unnamed IMT 16
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="pa_for_unnamed_imt_16"
                          name="pa_for_unnamed_imt_16"
                          render={({ field }) => {
                            return (
                              <label
                                id="pa_for_unnamed_imt_16_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="pa_paid_driver_imt_15"
                        className="label-control"
                      >
                        PA Paid Driver IMT 15
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="pa_paid_driver_imt_15"
                          name="pa_paid_driver_imt_15"
                          render={({ field }) => {
                            return (
                              <label
                                id="pa_paid_driver_imt_15_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="cng_kit" className="label-control">
                        CNG Kit
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="cng_kit"
                          name="cng_kit"
                          render={({ field }) => {
                            return (
                              <label
                                id="cng_kit_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="total_other_tp" className="label-control">
                        Total Other TP
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="total_other_tp"
                          name="total_other_tp"
                          render={({ field }) => {
                            return (
                              <label
                                id="total_other_tp_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="net_tp_premium" className="label-control">
                        Net TP Premium
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="net_tp_premium"
                          name="net_tp_premium"
                          render={({ field }) => {
                            return (
                              <label
                                id="net_tp_premium_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="total_od_tp_comprehensive"
                        className="label-control"
                      >
                        Net OD + TP Premium
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="total_od_tp_comprehensive"
                          name="total_od_tp_comprehensive"
                          render={({ field }) => {
                            return (
                              <label
                                id="total_od_tp_comprehensive_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="gst_od_tp_comprehensive"
                        className="label-control"
                      >
                        GST Amt
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="gst_od_tp_comprehensive"
                          name="gst_od_tp_comprehensive"
                          render={({ field }) => {
                            return (
                              <label
                                id="gst_od_tp_comprehensive_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="total_premium_with_tax_comprehensive"
                        className="label-control"
                      >
                        {/* Total Premium with Tax Comprehensive */}
                        Gross OD + TP Premium
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="total_premium_with_tax_comprehensive"
                          name="total_premium_with_tax_comprehensive"
                          render={({ field }) => {
                            return (
                              <label
                                id="total_premium_with_tax_comprehensive_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Final Details  */}
                  <div className="col-12 border-bottom mb-2">
                    <h6 className="text-primary">Final Details </h6>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="renewal_plan_final"
                        className="label-control"
                      >
                        Recommended Plan
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="renewal_plan_final"
                          name="renewal_plan_final"
                          render={({ field }) => {
                            return (
                              <label
                                id="renewal_plan_final_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="renewal_final_amt"
                        className="label-control"
                      >
                        Renewal Final Amount
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="renewal_final_amt"
                          name="renewal_final_amt"
                          render={({ field }) => {
                            return (
                              <label
                                id="renewal_final_amt_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="renewal_status" className="label-control">
                        Renewal Status
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="renewal_status"
                          name="renewal_status"
                          render={({ field }) => {
                            return (
                              <label
                                id="renewal_status_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="renewal_confirm_date"
                        className="label-control"
                      >
                        Renewal Confirm Date
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="renewal_confirm_date"
                          name="renewal_confirm_date"
                          render={({ field }) => {
                            return (
                              <label
                                id="renewal_confirm_date_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? moment(field.value).format("DD-MM-YYYY")
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="paid_through" className="label-control">
                        Paid Through
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="paid_through"
                          name="paid_through"
                          render={({ field }) => {
                            return (
                              <label
                                id="paid_through_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="cops_remarks" className="label-control">
                        Cops Remarks
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="cops_remarks"
                          name="cops_remarks"
                          render={({ field }) => {
                            return (
                              <label
                                id="cops_remarks_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="neft_received" className="label-control">
                        NEFT Received
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="neft_received"
                          name="neft_received"
                          render={({ field }) => {
                            return (
                              <label
                                id="neft_received_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="neft_receive_date"
                        className="label-control"
                      >
                        NEFT Receive Date
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="neft_receive_date"
                          name="neft_receive_date"
                          render={({ field }) => {
                            return (
                              <label
                                id="neft_receive_date_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? moment(field.value).format("DD-MM-YYYY")
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="neft_amount" className="label-control">
                        NEFT Amount
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="neft_amount"
                          name="neft_amount"
                          render={({ field }) => {
                            return (
                              <label
                                id="neft_amount_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="neft_reference_no"
                        className="label-control"
                      >
                        NEFT Reference No
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="neft_reference_no"
                          name="neft_reference_no"
                          render={({ field }) => {
                            return (
                              <label
                                id="neft_reference_no_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="neft_approved_cops"
                        className="label-control"
                      >
                        NEFT Approved Cops
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="neft_approved_cops"
                          name="neft_approved_cops"
                          render={({ field }) => {
                            return (
                              <label
                                id="neft_approved_cops_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="neft_cops_remarks"
                        className="label-control"
                      >
                        NEFT Cops Remarks
                      </label>
                      <div className="my-1">
                        <Controller
                          className="form-control"
                          control={control}
                          id="neft_cops_remarks"
                          name="neft_cops_remarks"
                          render={({ field }) => {
                            return (
                              <label
                                id="neft_cops_remarks_label"
                                className="border-0 fw-bold"
                              >
                                {field.value && field.value !== null
                                  ? field.value
                                  : "-"}
                              </label>
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label htmlFor="created_by" className="label-control">
                                                Created By
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="created_by"
                                                    name="created_by"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='created_by_label' className='border-0 fw-bold'>{field.value && field.value !== null ? field.value : '-'}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label htmlFor="created_at" className="label-control">
                                                Created At
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="created_at"
                                                    name="created_at"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='created_at_label' className='border-0 fw-bold'>{field.value && field.value !== null ? field.value : '-'}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label
                                                htmlFor="last_modified_by"
                                                className="label-control"
                                            >
                                                Last Modified By
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="last_modified_by"
                                                    name="last_modified_by"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='last_modified_by_label' className='border-0 fw-bold'>{field.value && field.value !== null ? field.value : '-'}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-3 mb-3">
                                        <div className="form-group">
                                            <label
                                                htmlFor="last_modified_at"
                                                className="label-control"
                                            >
                                                Last Modified At
                                            </label>
                                            <div className='my-1'>
                                                <Controller
                                                    className="form-control"
                                                    control={control}
                                                    id="last_modified_at"
                                                    name="last_modified_at"
                                                    render={({ field }) => {
                                                        return (
                                                            <label id='last_modified_at_label' className='border-0 fw-bold'>{field.value && field.value !== null ? field.value : '-'}</label>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div> */}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-12 mb-2">
                  <h5>Default Plan : {initialData?.default_plan} </h5>
                </div>

                {/* Add on 1 */}
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="card">
                    <div className="card-header d-flex justify-content-between">
                      <h6 className="mb-0">Plan 1</h6>
                      {/* <p className="mb-0">
                                                Status:
                                                {initialData?.plan_1_active === "yes" ? (
                                                    <span className="ml-1 text-success">Active</span>
                                                ) : (
                                                    <span className="ml-1 text-danger">Inactive</span>
                                                )}
                                            </p> */}
                    </div>
                    <div className="card-body">
                      <div className="form-group">
                        <label htmlFor="add_on_1" className="label-control">
                          Addon 1 (%)
                        </label>
                        <div className="my-1">
                          <Controller
                            className="form-control"
                            control={control}
                            id="add_on_1"
                            name="add_on_1"
                            render={({ field }) => {
                              return (
                                <label
                                  id="add_on_1_label"
                                  className="border-0 fw-bold"
                                >
                                  {field.value && field.value !== null
                                    ? field.value
                                    : "-"}
                                </label>
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-group mt-3">
                        <label
                          htmlFor="add_on_1_premium"
                          className="label-control"
                        >
                          Addon 1 Premium
                        </label>
                        <div className="my-1">
                          <Controller
                            className="form-control"
                            control={control}
                            id="add_on_1_premium"
                            name="add_on_1_premium"
                            render={({ field }) => {
                              return (
                                <label
                                  id="add_on_1_premium_label"
                                  className="border-0 fw-bold"
                                >
                                  {field.value && field.value !== null
                                    ? field.value
                                    : "-"}
                                </label>
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-group mt-3">
                        <label htmlFor="gold_extra_1" className="label-control">
                          Gold Extra
                        </label>
                        <div className="my-1">
                          <Controller
                            className="form-control"
                            control={control}
                            id="gold_extra_1"
                            name="gold_extra_1"
                            render={({ field }) => {
                              return (
                                <label
                                  id="gold_extra_1_label"
                                  className="border-0 fw-bold"
                                >
                                  {field.value && field.value !== null
                                    ? field.value
                                    : "-"}
                                </label>
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-group mt-3">
                        <label
                          htmlFor="total_od_tp_add_on_1"
                          className="label-control"
                        >
                          Total OD TP Add-On 1
                        </label>
                        <div className="my-1">
                          <Controller
                            className="form-control"
                            control={control}
                            id="total_od_tp_add_on_1"
                            name="total_od_tp_add_on_1"
                            render={({ field }) => {
                              return (
                                <label
                                  id="total_od_tp_add_on_1_label"
                                  className="border-0 fw-bold"
                                >
                                  {field.value && field.value !== null
                                    ? field.value
                                    : "-"}
                                </label>
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-group mt-3">
                        <label
                          htmlFor="gst_od_tp_add_on_1"
                          className="label-control"
                        >
                          GST OD TP Add-On 1
                        </label>
                        <div className="my-1">
                          <Controller
                            className="form-control"
                            control={control}
                            id="gst_od_tp_add_on_1"
                            name="gst_od_tp_add_on_1"
                            render={({ field }) => {
                              return (
                                <label
                                  id="gst_od_tp_add_on_1_label"
                                  className="border-0 fw-bold"
                                >
                                  {field.value && field.value !== null
                                    ? field.value
                                    : "-"}
                                </label>
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-group mt-3">
                        <label
                          htmlFor="total_premium_with_tax_add_on_1"
                          className="label-control"
                        >
                          Total Premium with Tax Addon 1
                        </label>
                        <div className="my-1">
                          <Controller
                            className="form-control"
                            control={control}
                            id="total_premium_with_tax_add_on_1"
                            name="total_premium_with_tax_add_on_1"
                            render={({ field }) => {
                              return (
                                <label
                                  id="total_premium_with_tax_add_on_1_label"
                                  className="border-0 fw-bold"
                                >
                                  {field.value && field.value !== null
                                    ? field.value
                                    : "-"}
                                </label>
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-group mt-3">
                        <label
                          htmlFor="add_on_1_remarks"
                          className="label-control"
                        >
                          Cops Remarks 1
                        </label>
                        <div className="my-1">
                          <Controller
                            className="form-control"
                            control={control}
                            id="add_on_1_remarks"
                            name="add_on_1_remarks"
                            render={({ field }) => {
                              return (
                                <label
                                  id="add_on_1_remarks"
                                  className="border-0 fw-bold"
                                >
                                  {field.value && field.value !== null
                                    ? field.value
                                    : "-"}
                                </label>
                              );
                            }}
                          />
                        </div>
                      </div>
                      {/* <div className="form-group mt-3">
                                                <label
                                                    htmlFor="plan_1_active"
                                                    className="label-control"
                                                >
                                                    Status

                                                </label>
                                                <div className='my-1'>
                                                    <Controller
                                                        className="form-control"
                                                        control={control}
                                                        id="plan_1_active"
                                                        name="plan_1_active"
                                                        render={({ field }) => {
                                                            return (
                                                                <label id='plan_1_active_label' className='border-0 fw-bold'>{field.value && field.value !== null ? field.value : '-'}</label>
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div> */}
                    </div>
                  </div>
                </div>
                {/* Add on 2 */}
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="card">
                    <div className="card-header d-flex justify-content-between">
                      <h6 className="mb-0">Plan 2 </h6>
                      {/* <p className="mb-0">
                                                Status:
                                                {initialData?.plan_1_active === "yes" ? (
                                                    <span className="ml-1 text-success">Active</span>
                                                ) : (
                                                    <span className="ml-1 text-danger">Inactive</span>
                                                )}
                                            </p> */}
                    </div>
                    <div className="card-body">
                      <div className="form-group">
                        <label htmlFor="add_on_2" className="label-control">
                          Addon 2 (%)
                        </label>
                        <div className="my-1">
                          <Controller
                            className="form-control"
                            control={control}
                            id="add_on_2"
                            name="add_on_2"
                            render={({ field }) => {
                              return (
                                <label
                                  id="add_on_2_label"
                                  className="border-0 fw-bold"
                                >
                                  {field.value && field.value !== null
                                    ? field.value
                                    : "-"}
                                </label>
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-group mt-3">
                        <label
                          htmlFor="add_on_2_premium"
                          className="label-control"
                        >
                          Addon 2 Premium
                        </label>
                        <div className="my-1">
                          <Controller
                            className="form-control"
                            control={control}
                            id="add_on_2_premium"
                            name="add_on_2_premium"
                            render={({ field }) => {
                              return (
                                <label
                                  id="add_on_2_premium_label"
                                  className="border-0 fw-bold"
                                >
                                  {field.value && field.value !== null
                                    ? field.value
                                    : "-"}
                                </label>
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-group mt-3">
                        <label htmlFor="gold_extra_2" className="label-control">
                          Gold Extra
                        </label>
                        <div className="my-1">
                          <Controller
                            className="form-control"
                            control={control}
                            id="gold_extra_2"
                            name="gold_extra_2"
                            render={({ field }) => {
                              return (
                                <label
                                  id="gold_extra_2_label"
                                  className="border-0 fw-bold"
                                >
                                  {field.value && field.value !== null
                                    ? field.value
                                    : "-"}
                                </label>
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-group mt-3">
                        <label
                          htmlFor="total_od_tp_add_on_2"
                          className="label-control"
                        >
                          Total OD TP Add-On 2
                        </label>
                        <div className="my-1">
                          <Controller
                            className="form-control"
                            control={control}
                            id="total_od_tp_add_on_2"
                            name="total_od_tp_add_on_2"
                            render={({ field }) => {
                              return (
                                <label
                                  id="total_od_tp_add_on_2_label"
                                  className="border-0 fw-bold"
                                >
                                  {field.value && field.value !== null
                                    ? field.value
                                    : "-"}
                                </label>
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-group mt-3">
                        <label
                          htmlFor="gst_od_tp_add_on_2"
                          className="label-control"
                        >
                          GST OD TP Add-On 2
                        </label>
                        <div className="my-1">
                          <Controller
                            className="form-control"
                            control={control}
                            id="gst_od_tp_add_on_2"
                            name="gst_od_tp_add_on_2"
                            render={({ field }) => {
                              return (
                                <label
                                  id="gst_od_tp_add_on_2_label"
                                  className="border-0 fw-bold"
                                >
                                  {field.value && field.value !== null
                                    ? field.value
                                    : "-"}
                                </label>
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-group mt-3">
                        <label
                          htmlFor="total_premium_with_tax_add_on_2"
                          className="label-control"
                        >
                          Total Premium with Tax Addon 2
                        </label>
                        <div className="my-1">
                          <Controller
                            className="form-control"
                            control={control}
                            id="total_premium_with_tax_add_on_2"
                            name="total_premium_with_tax_add_on_2"
                            render={({ field }) => {
                              return (
                                <label
                                  id="total_premium_with_tax_add_on_2_label"
                                  className="border-0 fw-bold"
                                >
                                  {field.value && field.value !== null
                                    ? field.value
                                    : "-"}
                                </label>
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="form-group mt-3">
                        <label
                          htmlFor="add_on_2_remarks"
                          className="label-control"
                        >
                          Cops Remarks 2
                        </label>
                        <div className="my-1">
                          <Controller
                            className="form-control"
                            control={control}
                            id="add_on_2_remarks"
                            name="add_on_2_remarks"
                            render={({ field }) => {
                              return (
                                <label
                                  id="add_on_2_remarks"
                                  className="border-0 fw-bold"
                                >
                                  {field.value && field.value !== null
                                    ? field.value
                                    : "-"}
                                </label>
                              );
                            }}
                          />
                        </div>
                      </div>
                      {/* <div className="form-group mt-3">
                                                <label
                                                    htmlFor="plan_2_active"
                                                    className="label-control"
                                                >
                                                    Status

                                                </label>
                                                <div className='my-1'>
                                                    <Controller
                                                        className="form-control"
                                                        control={control}
                                                        id="plan_2_active"
                                                        name="plan_2_active"
                                                        render={({ field }) => {
                                                            return (
                                                                <label id='plan_2_active_label' className='border-0 fw-bold'>{field.value && field.value !== null ? field.value : '-'}</label>
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div> */}
                    </div>
                  </div>
                </div>
                <div className="col-12 mt-1">
                  <div className="row">
                    {document && document.length > 0 && (
                      <>
                        <div className="col-12 mt-1">
                          <div className="form-group">
                            <label className="label-control mb-1">
                              Document
                            </label>
                            <div className="row">
                              {document && document.length > 0 ? (
                                document.map((objLink, index) => (
                                  <>
                                    <div className="col-12 col-md-4 col-xl-3">
                                      <div className="card shadow bg-light rounded mb-1 ">
                                        <div className="card-body d-flex justify-content-between py-1">
                                          <a
                                            className="primary"
                                            onClick={() => {
                                              dispatch(
                                                actionDownload({dmsIds: [objLink?.id]})
                                              );
                                            }}
                                          >
                                            {objLink.actual_uploaded_file_name}
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ))
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="col-12 mt-1">
                    <div className="row">
                      {employeeDocuments && employeeDocuments?.length > 0 && (
                        <>
                          <div className="col-12 mt-1">
                            <div className="form-group">
                              <label className="label-control mb-1">
                                Employee Document
                              </label>
                              <div className="row">
                                {employeeDocuments && employeeDocuments?.length > 0 ? (
                                  employeeDocuments.map((objLink, index) => (
                                    <>
                                      <div className="col-12 col-md-4 col-xl-3">
                                        <div className="card shadow bg-light rounded mb-1 ">
                                          <div className="card-body d-flex justify-content-between py-1">
                                            <a
                                              className="primary"
                                              onClick={() => {
                                                dispatch(
                                                  actionDownload({dmsIds: [objLink?.id]})
                                                );
                                              }}
                                            >
                                              {objLink.actual_uploaded_file_name}
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ))
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="row mb-3">
                                <div className="col-4 ">
                                    <div className="form-group">
                                        <label htmlFor="gold_extra" className="label-control">
                                            Gold Extra
                                        </label>
                                        <div className='my-1'>
                                            <Controller
                                                className="form-control"
                                                control={control}
                                                id="gold_extra"
                                                name="gold_extra"
                                                render={({ field }) => {
                                                    return (
                                                        <label id='gold_extra_label' className='border-0 fw-bold'>{field.value && field.value !== null ? field.value : '-'}</label>
                                                    );
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div> */}
              {/* <div className="form-actions border-0 float-none mt-1">
                <button
                  className="btn btn-outline-secondary mr-1 shadow round text-uppercase"
                  onClick={(event) => {
                    event.preventDefault();
                    navigate(-1);
                  }}
                >
                  Close
                </button>
              </div> */}
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default QuoteDetails;
